import React from 'react';

import { Tooltip } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs, { Dayjs } from 'dayjs';

import { IPalmDatePickerProps } from './IPalmDatePickerProps';

export function PalmDatePicker(props: Readonly<IPalmDatePickerProps>) {
    const [pickerValue, setPickerValue] = React.useState<Dayjs | null>(
        props.value ? dayjs(props.value) : null
    );

    // Allow parent to propagate changes down, but only update pickerValue when
    // props.value is not empty OR the field is disabled. This ensures the
    // input field isn't cleared while typing but can be cleared when disabled
    React.useEffect(() => {
        if (props.value !== '' || props.disabled) {
            setPickerValue(props.value ? dayjs(props.value) : null);
        }
    }, [props.value, props.disabled]);

    const handleDateChange = (newValue: Dayjs | null) => {
        setPickerValue(newValue);
        const formattedDate = formatDate(newValue);
        props.onChange(formattedDate);
    };

    const formatDate = (date: Dayjs | null) => date?.isValid() ? date.format('YYYY-MM-DD') : '';

    return (
        <Tooltip title={props.required ? '' : 'Optional'}>
            <div>
                <DesktopDatePicker
                    label={props.label}
                    disabled={props.disabled}
                    format="MM/DD/YYYY"
                    onChange={handleDateChange}
                    slotProps={{
                        textField: {
                            required: props.required,
                            inputProps: {
                                'data-testid': props.testId,
                            }
                        }
                    }}
                    value={pickerValue}
                ></DesktopDatePicker>
            </div>
        </Tooltip>
    );
}
